import axios from '@axios'
import store from "@/store"

let pendingAllItemsRequest = null
let allItemsCacheVersion = 0

const invalidateAllItemsCache = commit => {
  allItemsCacheVersion += 1
  pendingAllItemsRequest = null
  commit('setAllItems', [])
}

export default {
  namespaced: true,
  state: {
    items: [],
    allItems: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getAllItems(state) {
      return state.allItems
    },
    getSelectedItems(state) {
      return state.items.map(type_alarm => ({
        value: type_alarm.id,
        label: type_alarm.description,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setAllItems(state, value) {
      state.allItems = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      params.max = 1000;
      const response = await axios.get('v1/type_alarm',
                                        {
                                          params,
                                          responseType: params?.action == 'export' ? 'blob': 'json'
                                        })

      if (!response.data) {
        return []
      }

      if (params?.action == 'export') {
        const url = window.URL.createObjectURL(new Blob([response.data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download',
            response.headers["content-disposition"].split("filename=")[1]);
        document.body.appendChild(link);
        link.click();
        link.remove();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: 'type-alarm',
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: 'Reporte de tipo de alarma',
          body: 'Descarga completa',
          error: false,
          timestamp: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString()
        }
        store.dispatch('grid/updateDownloadNotification', notification)
      } else {
        commit('setData', response.data.data)
        return response.data
      }
    },
    async add({ commit }, params) {
      const { data } = await axios.post('v1/type_alarm', params)

      invalidateAllItemsCache(commit)
      return data
    },
    async edit({ commit }, { id, params }) {
      const { data } = await axios.put(`v1/type_alarm/${id}`, params)

      invalidateAllItemsCache(commit)
      return data
    },
    async delete({ commit }, id) {
      const { data } = await axios.delete(`v1/type_alarm/${id}`)

      invalidateAllItemsCache(commit)
      return data
    },
    async getAllUnpaginated({ state, commit }, { force = false } = {}) {
      if (!force && state.allItems.length) {
        return state.allItems
      }

      if (!force && pendingAllItemsRequest) {
        return pendingAllItemsRequest
      }

      if (force) {
        allItemsCacheVersion += 1
        pendingAllItemsRequest = null
      }

      const requestCacheVersion = allItemsCacheVersion
      const request = axios.get('v1/type_alarm')
        .then(response => {
          const filteredItems = (response.data?.data || []).map(item => ({
            id: item.id,
            description: item.description,
            color: item.color,
            text_color: item.text_color,
            color_icon: item.color_icon,
            icon: item.icon,
          }))

          if (requestCacheVersion === allItemsCacheVersion) {
            commit('setAllItems', filteredItems)
          }

          return filteredItems
        })
        .finally(() => {
          if (pendingAllItemsRequest === request) {
            pendingAllItemsRequest = null
          }
        })

      pendingAllItemsRequest = request
      return request
    },
    clear({ commit }) {
      commit('setData', [])
      invalidateAllItemsCache(commit)
    }
  },
}
